var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'layout-loading': true,
    'inline-with-buttons': _vm.withButton,
    'inline-with-text': _vm.withText,
  }},[_c('img',{attrs:{"src":"/loading.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }